import * as React from 'react';
import { Link as LinkR } from 'react-router-dom';

import ArrowDown from 'components/svg/ArrowDown';
import ArrowNav from 'components/svg/ArrowNav';
import * as styles from './link.scss';

type Props = {
    className?: string;
    href: string;
    target?: string;
    internal?: boolean;
    arrowDown?: boolean;
    arrowRight?: boolean;
    arrowNav?: boolean;
    arrowNavPos?: 'before' | 'after';
}

const Link: React.SFC<Props> = props => {
    return (
        <>
            {props.internal ? (
                <LinkR
                    className={
                        styles.link +
                        (props.className ? ' ' + props.className : '')
                    }
                    to={props.href}
                >
                    {props.arrowNav && props.arrowNavPos ==='before' && <ArrowNav className={styles.arrowNavBefore}/>}
                    {props.children}
                    {props.arrowNav && props.arrowNavPos ==='after' && <ArrowNav className={styles.arrowNav}/>}
                    {props.arrowRight && <ArrowNav className={styles.arrowRight} />}
                    {props.arrowDown && <ArrowDown className={styles.arrowDown} />}
                </LinkR>
            ) : (
                <a
                    className={
                        styles.link +
                        (props.className ? ' ' + props.className : '')
                    }
                    href={props.href}
                    target={props.target ? props.target : ''}
                >
                    {props.children}
                    {props.arrowNav && <ArrowNav className={styles.arrowNav} />}
                    {props.arrowRight && <ArrowNav className={styles.arrowRight} />}
                    {props.arrowDown && <ArrowDown className={styles.arrowDown} />}
                </a>
            )}

           

            
        </>
    );
};

Link.defaultProps = {
    internal: true,
    arrowNavPos: 'after'
};

export default Link;
